// extracted by mini-css-extract-plugin
export var arrows = "_p-6";
export var decrementer = "_p-a";
export var disabled = "_p-4";
export var error = "_p-1";
export var hiddenText = "_p-b";
export var incrementer = "_p-9";
export var input = "_p-8";
export var inputWrapper = "_p-0";
export var leadingIcon = "_p-c";
export var readonly = "_p-3";
export var regular = "_p-7";
export var small = "_p-5";
export var warning = "_p-2";